<template>
  <b-container fluid class="pb-4">
    <!-- 工程別実績 -->
    <h1 class="fc-h1">{{this.$i18n.t('result.title')}}</h1>
    <form>
      <div class="w-100 mb-3">
        <b-card>
          <form>
             <!-- 日時 -->
            <b-form-group
              id="select_date"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('result.label_date')"
              label-for="input-horizontal"
            >
              <div class="d-flex align-items-center">
                <div class="flex-fill">
                  <b-form-input id="from" v-model="from" type="date"></b-form-input>
                </div>
                <div class="flex-fill">
                  <b-form-input id="fromTime" v-model="fromTime" type="time"></b-form-input>
                </div>
                <div class="flex-shrink-1 px-2">-</div>
                <div class="flex-fill">
                  <b-form-input id="to" v-model="to" type="date"></b-form-input>
                </div>
                <div class="flex-fill">
                  <b-form-input id="toTime" v-model="toTime" type="time"></b-form-input>
                </div>
              </div>
            </b-form-group>
            <!-- 型番 -->
            <b-form-group
              id="code"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('result.label_code')"
              label-for="input-horizontal"
            >
              <b-form-select v-model="selectedCode" :options="codes" class="mb-3"></b-form-select>
            </b-form-group>
            <!-- ライン -->
            <b-form-group
              id="line"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('result.label_line')"
              label-for="input-horizontal"
            >
              <b-form-select v-model="selectedLine" :options="lines" class="mb-3"></b-form-select>
            </b-form-group>
            <div>
              <!-- 検索 -->
              <b-button variant="primary" @click="search" class="float-right px-5">{{this.$i18n.t('result.button_search')}}</b-button>
            </div>
          </form>
        </b-card>
      </div>
    </form>
    <div v-if="isSearch">
      <b-card class="mb-3">
        <!-- 工程別実績 -->
        <h2
          :class="showCollapse ? 'collapsed' : null"
          :aria-expanded="showCollapse ? 'true' : 'false'"
          aria-controls="collapse-12"
          @click="showCollapse = !showCollapse"
        >{{this.$i18n.t('result.label_process_result')}}</h2>
        <b-collapse id="collapse-12" v-model="showCollapse" class="mt-3">
          <b-table
            :striped="striped"
            :bordered="bordered"
            :borderless="borderless"
            :outlined="outlined"
            :current-page="currentPage"
            :small="small"
            :hover="hover"
            :dark="dark"
            :fixed="fixed"
            :foot-clone="footClone"
            :no-border-collapse="noCollapse"
            :items="procItems"
            :fields="procFields"
            :head-variant="headVariant"
            :table-variant="tableVariant"
          >
          <template v-slot:[getCellValue(procField)]="row" v-for="procField in procFields">
            <span :key="procField.key">
              <u>
                <b-link
                  @click="serialSearch(row.item, row.index, getKeyValue(procField))"
                  :class="showCollapse ? 'collapsed' : null"
                  :aria-expanded="showCollapse ? 'true' : 'false'"
                  aria-controls="collapse-12"
                >{{ row.item[getKeyValue(procField)] }}</b-link>
              </u>
            </span>
           </template>
          </b-table>
          <!-- CSV出力 -->
          <b-button variant="primary" @click="codeCsv" class="float-right">{{this.$i18n.t('result.button_csv')}}</b-button>
        </b-collapse>
      </b-card>
    </div>
    <div v-if="isSerial">
      <div>
        <!-- シリアル一覧 -->
        <b-card :title="this.$i18n.t('result.label_serial_list')">
        <b-row>
          <b-col sm="5" md="1" class="my-1">
            <b-form-select
              v-model="perPage"
              id="perPageSelect"
              size="sm"
              :options="pageOptions"
            ></b-form-select>
          </b-col>
          <b-col sm="7" md="11" class="my-1">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="fill"
              size="sm"
              class="my-0"
            ></b-pagination>
          </b-col>
          </b-row>
          <b-table
            :striped="striped"
            :bordered="bordered"
            :borderless="borderless"
            :outlined="outlined"
            :current-page="currentPage"
            :small="small"
            :hover="hover"
            :dark="dark"
            :fixed="fixed"
            :foot-clone="footClone"
            :no-border-collapse="noCollapse"
            :items="serialItems"
            :fields="serialFields"
            :head-variant="headVariant"
            :table-variant="tableVariant"
            :per-page="perPage"
          >
            <template v-slot:cell(serial)="row">
              <u><b-link @click="calteFromOtherPage(row.item.serial)">{{ row.item.serial }}</b-link></u>
            </template>
          </b-table>
          <div>
            <!-- CSV出力 -->
            <b-button variant="primary" @click="serialCsv" class="float-right">{{this.$i18n.t('result.button_csv')}}</b-button>
          </div>
        </b-card>
      </div>
    </div>
    <!-- エラーメッセージ用 -->
    <confirm-modal modId="md-err" :msg="errMsg" :titleMsg="errSbj" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="errConfirm"/>
  </b-container>
</template>

<script>
import confirmModal from './ConfirmModal'

export default {
  components: {
    confirmModal
  },
  data () {
    return {
      pageOptions: [10, 20, 50, 100],
      perPage: 10,
      totalRows: 1,
      selectedCode: null,
      selectedLine: null,
      qtyFrom: null,
      qtyTo: null,
      note: null,
      currentPage: 1,
      codes: [
        { value: null, text: this.$i18n.t('result.label_all_code') }
      ],
      lines: [
        { value: null, text: this.$i18n.t('result.label_all_line') }
      ],
      procFields: [
      ],
      serialFields: [
        { key: 'serial', label: this.$i18n.t('result.label_serial'), sortable: true },
        { key: 'code', label: this.$i18n.t('result.label_code'), sortable: true },
        { key: 'date', label: this.$i18n.t('result.label_process_date'), sortable: true }
      ],
      procItems: [
      ],
      serialItems: [
      ],
      tableVariants: [
        'primary',
        'secondary',
        'info',
        'danger',
        'warning',
        'success',
        'light',
        'dark'
      ],
      striped: true,
      bordered: true,
      borderless: true,
      outlined: false,
      small: false,
      hover: true,
      dark: true,
      fixed: true,
      footClone: false,
      headVariant: 'dark',
      tableVariant: '',
      showCollapse: true,
      noCollapse: true,
      isSearch: false,
      isSerial: false,
      from: '',
      to: '',
      fromTime: '',
      defFromTime: '',
      toTime: '',
      defToTime: '',
      startForSearched: null,
      endForSearched: null,
      errMsg: null,
      errSbj: null
    }
  },
  async created () {
    var dates = await this.getDates()
    this.from = window.formatDate(dates.start, 'yyyy-MM-dd')
    this.to = window.formatDate(dates.end, 'yyyy-MM-dd')
    this.fromTime = window.formatDate(dates.start, 'HH:mm')
    this.defFromTime = this.fromTime
    this.toTime = window.formatDate(dates.end, 'HH:mm')
    this.defToTime = this.toTime

    this.searchProductinfo()
    this.searchLine()
  },
  methods: {
    // 検索アクション
    search: function () {
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }
      var body = {}
      // 日付
      if (this.from === '' && this.to === '') {
        this.errSbj = this.$i18n.t('result.title')
        this.errMsg = this.$i18n.t('result.err_day_hissu')
        this.$bvModal.show('md-err')
        return
      }
      var startDate = ''
      if (this.from !== '') {
        var from = ''
        if (this.fromTime !== '') {
          from = this.$moment(this.from + ' ' + this.fromTime, 'YYYY-MM-DD HH:mm')
        } else {
          from = this.$moment(this.from + ' ' + this.defFromTime, 'YYYY-MM-DD HH:mm:00')
        }
        startDate = from.utc().format('YYYY-MM-DD HH:mm:ss')
        body.start = startDate
      }
      // シリアル実績一覧取得用に入力された日時を保持しておく
      this.startForSearched = startDate

      var endDate = ''
      if (this.to !== '') {
        var to = ''
        if (this.toTime !== '') {
          to = this.$moment(this.to + ' ' + this.toTime, 'YYYY-MM-DD HH:mm')
        } else {
          to = this.$moment(this.to + ' ' + this.defToTime, 'YYYY-MM-DD HH:mm:00')
        }

        endDate = to.utc().format('YYYY-MM-DD HH:mm:ss')
        body.end = endDate
      }
      // シリアル実績一覧取得用に入力された日時を保持しておく
      this.endForSearched = endDate

      // 日付論理チェック
      var cmpFrom = new Date(startDate)
      var cmpTo = new Date(endDate)
      if (cmpFrom.getTime() > cmpTo.getTime()) {
        this.errSbj = this.$i18n.t('result.title')
        this.errMsg = this.$i18n.t('result.err_from_to_reverse')
        this.$bvModal.show('md-err')
        return
      }

      body.codeinfo = this.selectedCode
      body.line = this.selectedLine

      // 工程別実績取得
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/result/resultByProcess', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            // 工程取得
            var processInfoList = res.data.processInfo
            var procFields = []

            // 整形
            var procField = {}
            procField.key = 'code'
            procField.label = this.$i18n.t('result.label_code')
            procField.sortable = true
            procFields.push(procField)
            for (var i = 0; i < processInfoList.length; i++) {
              procField = {}
              procField.key = processInfoList[i].process_id.toString()
              procField.label = processInfoList[i].process_name
              procField.sortable = true
              procFields.push(procField)
            }
            // 一旦データクリア
            this.procFields.splice(0)
            // データセット
            this.procFields.splice(0, 0, ...procFields)

            /// // 工程別実績取得
            var resultByProcessInfoList = res.data.resultByProcessInfo
            var procItems = []

            // 整形
            for (var j = 0; j < resultByProcessInfoList.length; j++) {
              var procItem = {}
              procItem.code = resultByProcessInfoList[j].code + ' - ' + resultByProcessInfoList[j].rev + ' - ' + resultByProcessInfoList[j].petname
              procItem.proCode = resultByProcessInfoList[j].code
              procItem.rev = resultByProcessInfoList[j].rev
              for (var k = 0; k < resultByProcessInfoList[j].countInfo.length; k++) {
                var countInfo = resultByProcessInfoList[j].countInfo[k]
                procItem[countInfo.processId.toString()] = countInfo.count
              }
              procItems.push(procItem)
            }
            // 一旦データクリア
            this.procItems.splice(0)
            // データセット
            this.procItems.splice(0, 0, ...procItems)
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
      // 検索結果表示
      this.isSearch = true
      this.isSerial = false
      this.showCollapse = true
    },
    // シリアルリンククリックアクション
    serialSearch: function (item, index, processId) {
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }
      var body = {}
      body.start = this.startForSearched
      body.end = this.endForSearched
      body.code = item.proCode
      body.rev = item.rev
      body.line = this.selectedLine
      body.process = processId

      // 実績シリアル一覧取得
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/result/resultSerial', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
          /// // シリアル一覧取得
            var serialInfoList = res.data.serialInfo
            var serialItems = []

            // 整形
            for (var i = 0; i < serialInfoList.length; i++) {
              var serialItem = {}
              serialItem.serial = serialInfoList[i].serial
              serialItem.code = serialInfoList[i].code + '_' + serialInfoList[i].rev + '_' + serialInfoList[i].petname
              // utc -> local 変換
              // momentオブジェクト(UTC)に変換
              var utc = this.$moment.utc(serialInfoList[i].passDate, 'YYYY-MM-DD HH:mm:ss')
              if (String(utc) === 'Invalid date') {
                serialItem.date = ''
              } else {
                // local時刻に変換＆フォーマット
                serialItem.date = utc.local().format('YYYY-MM-DD HH:mm:ss')
              }
              serialItems.push(serialItem)
            }
            // ページング設定
            this.totalRows = serialItems.length
            // 一旦データクリア
            this.serialItems.splice(0)
            // データセット
            this.serialItems.splice(0, 0, ...serialItems)
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
      // 検索結果表示
      this.isSerial = true
      this.showCollapse = false
    },
    searchProductinfo: function () {
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }

      var body = {}
      body.code = ''
      body.codeLikeFlg = ''
      body.rev = ''
      body.revLikeFlg = ''
      body.petname = ''
      body.efFlg = ''

      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      // 型番取得
      this.$axios
        .post(window.END_POINT + '/master/productinfo/select', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            var modelList = res.data.productInfo
            var codes = []

            // 整形
            for (var i = 0; i < modelList.length; i++) {
              var code = {}
              code.value = modelList[i].code + ',' + modelList[i].rev + ',' + modelList[i].petname
              code.text = modelList[i].code + ' - ' + modelList[i].rev + ' - ' + modelList[i].petname
              codes.push(code)
            }
            // 一旦データクリア
            this.codes.splice(1)
            // データセット
            this.codes.splice(1, 0, ...codes)
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    searchLine: function () {
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }

      var body = {}
      body.lineId = ''
      body.lineIdLikeFlg = ''
      body.lineName = ''
      body.base = ''
      body.lineKind = ''
      body.efFlg = ''

      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      // ライン取得
      this.$axios
        .post(window.END_POINT + '/master/line/select', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            var lineInfoList = res.data.lineInfo
            var lines = []

            // 整形
            for (var i = 0; i < lineInfoList.length; i++) {
              var line = {}
              line.value = lineInfoList[i].line_id
              line.text = lineInfoList[i].line_name
              lines.push(line)
            }
            // 一旦データクリア
            this.lines.splice(1)
            // データセット
            this.lines.splice(1, 0, ...lines)
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    // 工程別実績CSV出力
    codeCsv: function () {
      // タイトル設定
      var title = []
      this.procFields.forEach(el => {
        title.push('"' + el['label'] + '"')
      })
      var csv = title.join(',')
      csv += '\n'
      // データ設定
      var data = []
      this.procItems.forEach(el => {
        data = []
        data.push('"' + el['code'] + '"')

        var i = 0
        this.procFields.forEach(pro => {
          if (i === 0) {
            i++
            return
          }
          data.push('"' + el[pro['key']] + '"')
          i++
        })
        csv += data.join(',')
        csv += '\r\n'
      })
      // CSVダウンロード
      window.downloadCsv(csv, 'ResultByprocess')
    },
    // シリアル一覧CSV出力
    serialCsv: function () {
      // タイトル設定
      var title = []
      this.serialFields.forEach(el => {
        title.push('"' + el['label'] + '"')
      })
      var csv = title.join(',')
      csv += '\r\n'
      // データ設定
      var data = []
      this.serialItems.forEach(el => {
        data = []
        data.push('"' + el['serial'] + '"')
        data.push('"' + el['code'] + '"')
        data.push('"' + el['date'] + '"')
        csv += data.join(',')
        csv += '\r\n'
      })
      // CSVダウンロード
      window.downloadCsv(csv, 'ResultSerial')
    },
    // cellの値取得
    getCellValue: function (key) {
      if (key.key === 'code') {
        return ''
      }
      return `cell(${key.key})`
    },
    // cellの値取得
    getKeyValue: function (key) {
      return key.key
    },
    getDates: async function () {
      var startTime = ''
      var dates = []
      // 開始時間取得
      var reqObj = {}
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      await this.$axios
        .post(window.END_POINT + '/common/selectStartTime', reqObj, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            startTime = res.data.shift_start_time
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
          console.log(res)
        })

      // 日またぎ確認、時間取得
      var nowTime = window.formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss')
      dates = window.getStartTime(startTime, nowTime, false)

      return dates
    },
    errConfirm: function () {
      this.$bvModal.hide('md-err')
    },
    calteFromOtherPage: function (serial) {
      var path = '/calte'
      this.$router.push({ path: path, query: {serial: [serial]} })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Result.vue